import { Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AfterSubmit = ({ number }) => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center' }}>
      <h1 style={{ fontWeight: 'bold' }}> {number} تم ارسال طلبك بنجاح</h1>
      <Button onClick={() => navigate('/')}>الرجوع</Button>
    </div>
  );
};

export default AfterSubmit;
